import { DefaultOption } from '../../components/Options/DefaultOption';
import { OptionWithCheckIcon } from '../../components/Options/OptionWithCheckIcon';
import { OptionWithImage } from '../../components/Options/OptionWithImage';
import type { SelectorOptionType } from '../../types';
import { SelectorOptionTypes } from '../../types';

export const getOptionsComponent = (optionType: SelectorOptionType) => {
  switch (optionType) {
    case SelectorOptionTypes.DEFAULT:
      return DefaultOption;
    case SelectorOptionTypes.IMAGE:
      return OptionWithImage;
    case SelectorOptionTypes.CHECK_ICON:
      return OptionWithCheckIcon;
    default:
      return DefaultOption;
  }
};